"use client";

import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProductDetails() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const features = [{
    number: "01",
    title: "Overview",
    description: "Mineral wool sandwich panels combine a non-combustible mineral wool core with steel facings to provide superior fire safety rated A1. Excellent thermal insulation properties with conductivity values ensuring energy efficiency. Optimal for demanding construction environments."
  }, {
    number: "02",
    title: "Key Advantages",
    description: "Fire class A1 rating ensures maximum safety compliance. Superior sound insulation properties reduce noise transmission. Exceptional thermal performance maintains temperature stability. Lightweight design simplifies installation and reduces structural load."
  }, {
    number: "03",
    title: "Applications",
    description: "Industrial halls and manufacturing facilities. Warehouses and logistics centers. Cold storage and refrigerated environments. Commercial building envelopes. Cleanrooms and specialized facilities requiring fire-safe construction."
  }, {
    number: "04",
    title: "Technical Specifications",
    description: "Panel thickness: 50-200mm available. Mineral wool density: 110-130 kg/m³. Upper steel facing: galvanized or pre-painted. Lower steel facing: galvanized or aluminum. CE marking and full compliance with European building standards."
  }];
  return <section data-section-id="5077" id="product-details" className="bg-background text-foreground py-24 md:py-40 px-6 md:px-12 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-20 md:mb-32 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="md:col-span-4 flex flex-col">
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              Rock Wool Sandwich Panels
            </span>
            <div className="mt-6 w-px h-24 md:h-32" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
          </div>

          {}
          <div className="md:col-span-8">
            <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[80px] leading-[1.05]" style={{
            letterSpacing: "-0.03em"
          }}>
              Rock Wool Sandwich Panels
            </h2>
            <p className="mt-6 text-xl md:text-2xl text-muted-foreground font-default">
              Fire-safe insulation for roofs and walls
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-12">
          {features.map((feature, i) => {
          return <FeatureBlock key={feature.number} data-index={i} number={feature.number} title={feature.title} description={feature.description} delay={i * 120} />;
        })}
        </div>
      </div>
    </section>;
}
function FeatureBlock({
  number,
  title,
  description,
  delay,
  ...rest
}: {
  number: string;
  title: string;
  description: string;
  delay: number;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} className={`relative flex flex-col transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${delay}ms`
  }} {...rest}>
      {}
      <span className="font-mono text-3xl md:text-4xl font-medium leading-none" style={{
      color: "var(--primary)"
    }}>
        {number}
      </span>

      {}
      <div className="mt-6 h-px w-full" style={{
      backgroundColor: "var(--border)"
    }} aria-hidden="true" />

      {}
      <h3 className="font-default font-semibold text-2xl md:text-3xl mt-8 leading-tight tracking-tight">
        {title}
      </h3>

      {}
      <p className="font-default text-base md:text-[17px] mt-5 text-muted-foreground" style={{
      lineHeight: 1.7,
      maxWidth: "420px"
    }}>
        {description}
      </p>

      {}
      <div className="mt-8 flex justify-end">
        <ChevronRight className="size-6 stroke-[1.25]" style={{
        color: "var(--primary)"
      }} aria-hidden="true" />
      </div>
    </div>;
}